import { ApiError } from '@/services/api'

/** The API's own reason when it gave one (a 422 names the variable or host to fix), else the HTTP line. */
export function settingsErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof ApiError) {
    const detail = (error.data as { detail?: unknown } | undefined)?.detail
    if (typeof detail === 'string' && detail) return detail
  }
  return error instanceof Error ? error.message : fallback
}
